export default {
  home: {
    resumo: {
      cupons_help_text: 'Quantidade de cupons no mês',
      cupons: 'Cupons',
      faturamento: 'Faturamento',
      ticket_medio_geral_help_text: 'Média do valor de todos os cupons em {mesAno}',
      ticket_medio_geral: 'Ticket médio geral',
      variacao_faturamento_help_text: 'Dados coletados até {mesAnterior}. Faturamento do ano anterior até esta data: R$ {faturamentoAnterior}',
      variacao_faturamento: 'Variação do faturamento',
    },
    clube: {
      clientes_ativos_help_text: 'Clientes que fizeram pelo menos uma compra em {mesAno}',
      clientes_ativos: 'Clientes ativos',
      novos_cadastros_help_text: 'Clientes cadastrados em {mesAtual}',
      novos_cadastros: 'Novos cadastros',
      percentual_faturamento_help_text: 'Percentual do faturamento identificado em {mesAtual}',
      percentual_faturamento: 'Percentual do faturamento',
      ticket_medio_clube_help_text: 'Média do valor de todos os cupons de clientes do clube em {mesAno}',
      ticket_medio_clube: 'Ticket médio clube',
    },
    insights: {
      clientes_inativos_help_text: 'Clientes que compraram no mês retrasado e não compraram mais',
      clientes_inativos: 'Clientes inativos recentes',
      cupons_cliente_clube_help_text: 'Média de cupons por cliente clube em {mesAno}',
      cupons_cliente_clube: 'Média de cupons por cliente do clube',
      diferenca_ticket_medio_help_text: 'Percentual de variação no ticket médio de clientes no clube em relação ao ticket médio de clientes fora do clube',
      diferenca_ticket_medio: 'Diferença do ticket médio',
      gasto_medio_clube_help_text: 'Média de gasto por cliente clube no mês',
      gasto_medio_clube: 'Gasto médio no clube',
    },
  },
}
